import { WarningIcon } from '@p2p/assets/svg';
import { Button } from '@p2p/components';
import { useScrollLock } from '@p2p/shared/hooks';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import styles from './styles.module.scss';

interface IModalIncrementAppliedProps {
  uid: string;
  sumText: string;
  isCancelModalOpen: boolean;
  showCancelModal: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const ID = `modal_increment_applied`;
const checkIsShowed = (id: string) => {
  const lastShowed = localStorage.getItem(ID);

  return !!lastShowed && lastShowed === id;
};

export const ModalIncrementApplied: FC<IModalIncrementAppliedProps> = ({
  uid,
  sumText,
  isCancelModalOpen,
  showCancelModal,
  isOpen,
  setIsOpen,
}) => {
  const [searchParams] = useSearchParams();
  const hideIncrementModal = searchParams.get('hideIncrementModal') === 'true';
  const isShowed = checkIsShowed(uid);
  useScrollLock(!isShowed && !hideIncrementModal);

  const onClose = () => {
    showCancelModal();
  };

  if (isShowed || isCancelModalOpen || !isOpen || hideIncrementModal) {
    return null;
  }

  const handleAccept = () => {
    localStorage.setItem(ID, uid);
    setIsOpen(false);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <WarningIcon />
        <div className={styles.header}>
          <div className={styles.title}>Сумма платежа изменена на</div>
          <div className={styles.sum}>{sumText}</div>
        </div>
        <div className={styles.details}>
          <div className={styles.detailsTitle}>Зачем это нужно?</div>
          <div className={styles.detailsText}>
            Мы не нашли свободных реквизитов под вашу сумму, поэтому мы подобрали{' '}
            <span>ближайшую свободную.</span>
          </div>
          <div className={styles.detailsText}>
            Не переживайте, система автоматически обработает новую сумму и зачислит её <br />
            <span>в полном объеме!</span>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button onClick={handleAccept}>Переведу {sumText}</Button>
          <Button onClick={onClose} variant="outlined">
            Отменить платеж
          </Button>
        </div>
      </div>
    </div>
  );
};
